import * as React from 'react'
import { Platform, View } from 'react-native'
import { Skeleton } from '@components/Skeleton'
import { Spacer } from '@components/Spacer'
import { useGoal } from '@features/goals/hooks/useGoals'
import Metrics from '@themes/Metrics'
import { ProgressBar } from './ProgressBar'
import { ProgressMessage } from './ProgressMessage'

export function Widget() {
  const goalHook = useGoal()
  const goal = goalHook.goal

  if (!goalHook._goalQuery.data && goalHook._profileQuery.data) {
    return (
      <View
        style={{
          paddingHorizontal: Metrics.paddingHorizontal,
          flex: 1,
          minHeight: 38,
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Skeleton height={20} width={'65%'} />
        <Skeleton height={8} width={'100%'} />
      </View>
    )
  }

  if (!goal) return <Spacer height={Platform.OS === 'web' ? 38 : 0} />

  return (
    <View style={{ paddingHorizontal: Metrics.paddingHorizontal }}>
      <ProgressMessage
        targetValue={goal.targetValue}
        currentValue={goal.currentValue}
        period={goal.period}
      />
      <ProgressBar
        currentValue={goal.currentValue}
        targetValue={goal.targetValue}
      />
    </View>
  )
}
